import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { BaseProvider } from '../providers/base-provider';

@Injectable()
export class ConsumerBusinessTimelineProvider extends BaseProvider {
	constructor(		
		public http: Http,	
		public globals: Globals,
		public storage: Storage,
		public httpHelper: HttpHelper) {
		super();
	}

  	getTimeline(params){	
	  	this.url = this.globals.dataUrl + 'consumerBusinessMessage/timeline/business/'+ params.businessId + '/page/' + params.page + '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		if(params.page==1){
		    			this.list = res.Data;
		    		}else{
		    			this.pushItems(res.Data);	
		    		}
		    		
		        	if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}
}



// WEBPACK FOOTER //
// ./src/providers/consumer-business-timeline-handler.ts